import DestacatUltimaNoticia from './DestacatUltimaNoticia';
import DestacatUltimaNoticiaSkeleton from './DestacatUltimaNoticiaSkeleton';

export default function Component(props) {
    const { isLoading } = props;
    return isLoading ? <DestacatUltimaNoticiaSkeleton /> : <DestacatUltimaNoticia {...props} />;
}
